import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DetailFilterButtonList } from "@/components/Categories/Menu/DetailFilterButton";
import { CustomSelectMenuItem, CustomTextField, SearchResultAmount, SearchResultDescWrap } from "@/components/Categories/Menu/index";
import { FilterQueryHandlerType } from "@/hooks/useCategoryFilterHandler";
import { SelectedFilterWrapper } from "./SelectedFilter";
export const CategoryFilterSectionView = (param)=>{
    let { filterItems , hasFilterItems , handleMobileSlider , selectedFilterList , filterQueryHandler , totalCount , sortItems , selectedSort , isCheckFilterItem , isCheckFilterCount , mobileFilterSideSheet  } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            hasFilterItems && /*#__PURE__*/ _jsx(DetailFilterButtonList, {
                filterItems: filterItems,
                handleMobileSlider: handleMobileSlider,
                isCheckFilterItem: isCheckFilterItem,
                isCheckFilterCount: isCheckFilterCount,
                selectedFilterList: selectedFilterList,
                mobileFilterSideSheet: mobileFilterSideSheet,
                filterQueryHandler: filterQueryHandler
            }),
            selectedFilterList.length > 0 && /*#__PURE__*/ _jsx(SelectedFilterWrapper, {
                className: "category",
                position: undefined,
                button: /*#__PURE__*/ _jsx(SelectedFilterWrapper.ResetButton, {
                    handleResetFilter: ()=>filterQueryHandler({
                            filterType: FilterQueryHandlerType.RESET
                        })
                }),
                children: selectedFilterList.map((item, idx)=>{
                    return /*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                        className: "category current-btn",
                        label: item.value,
                        onRemove: ()=>filterQueryHandler({
                                filterType: FilterQueryHandlerType.DETAILFILTER,
                                filterName: item.key,
                                value: item.value
                            })
                    }, "selectedItem" + idx);
                })
            }),
            /*#__PURE__*/ _jsxs(SearchResultDescWrap, {
                children: [
                    /*#__PURE__*/ _jsxs(SearchResultAmount, {
                        children: [
                            "총 ",
                            totalCount,
                            "건"
                        ]
                    }),
                    sortItems.length > 0 && /*#__PURE__*/ _jsx(CustomTextField, {
                        select: true,
                        value: selectedSort !== null && selectedSort !== void 0 ? selectedSort : sortItems[0],
                        onChange: (e)=>{
                            filterQueryHandler({
                                filterType: FilterQueryHandlerType.SORT,
                                value: e.target.value
                            });
                        },
                        children: sortItems.map((option)=>{
                            return /*#__PURE__*/ _jsx(CustomSelectMenuItem, {
                                value: option,
                                className: "select",
                                children: option
                            }, option);
                        })
                    })
                ]
            })
        ]
    });
};
